import { axios } from "@cores/axiosWrapper";

export const getFavoritesAPI = async (apiEndpoint, projectId, params) => {
    return axios.get(`${apiEndpoint}/favorites`, {
        params,
        headers: {
            projectId,
        },
    });
};

export const addFavoriteAPI = async (apiEndpoint, projectId, data) => {
    return axios.post(`${apiEndpoint}/favorites`, data, {
        headers: {
            projectId,
        },
    });
};

export const removeFavoriteAPI = async (apiEndpoint, projectId, id) => {
    return axios.delete(`${apiEndpoint}/favorites/${id}`, {
        headers: {
            projectId,
        },
    });
};

export const bulkAddFavoriteAPI = async (apiEndpoint, projectId, data) => {
    return axios.post(`${apiEndpoint}/favorites:set`, data, {
        headers: {
            projectId,
        },
    });
};

export const bulkRemoveFavoriteAPI = async (apiEndpoint, projectId, data) => {
    return axios.post(`${apiEndpoint}/favorites:unset`, data, {
        headers: {
            projectId,
        },
    });
};
